import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { AppNoFeedback } from '../app/appNoFeedback';
import { ActivityDayTask } from './activityDayTask';
import { Activity } from '../../models/activity';
import { generateProjectLabel } from '../../services/projectService';

const style = {
  box: {
    display: 'flex',
    flexDirection: 'column',
  },

  boxSecond: {
    display: 'flex',
    flexWrap: 'wrap',
  },

  boxThird: {
    mb: 5,
  },

  appRow: {
    mb: 5,
  },

  typo: {
    mr: 2,
  },

  typoSecond: {
    ml: 3,
  },

  button: {
    mr: 2,
  },
} as const;

interface Props {
  activities: Activity[];
  onDeleteActivity(activity: Activity): void;
  onEditActivity(activity: Activity): void;
}

interface GroupActivities {
  totalHours: number;
  data: Activity[];
  name: string;
}

export function ActivityDay({
  activities,
  onDeleteActivity,
  onEditActivity,
}: Props): JSX.Element {
  const categorizedActivities = useMemo(
    () =>
      activities.reduce((data, current) => {
        const typeIndex = data.findIndex(
          (el) =>
            el.name ===
            generateProjectLabel(
              current.task.project.name,
              current.task.project.code
            )
        );

        if (typeIndex !== -1) {
          data[typeIndex].data.push(current);
          data[typeIndex].totalHours =
            (data[typeIndex].totalHours || 0) + current.hours;
        } else {
          data.push({
            name: generateProjectLabel(
              current.task.project.name,
              current.task.project.code
            ),
            data: [current],
            totalHours: current.hours,
          });
        }

        return data;
      }, [] as GroupActivities[]),
    [activities]
  );

  return (
    <Box sx={style.box}>
      <Box sx={style.boxSecond}>
        {activities.length == 0 && <AppNoFeedback info="task" />}
        <Box>
          {categorizedActivities.map((categoryActivity) => (
            <Box key={categoryActivity.name} sx={style.boxThird}>
              <Typography variant="h2" sx={style.typoSecond}>
                {categoryActivity.name} Total: {categoryActivity.totalHours}h
              </Typography>

              <Box sx={style.boxSecond}>
                {categoryActivity.data.map((activity) => (
                  <ActivityDayTask
                    key={activity.id}
                    activity={activity}
                    onDeleteActivity={onDeleteActivity}
                    onEditActivity={onEditActivity}
                  />
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
